import script from "./BigScreenDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./BigScreenDisplay.vue?vue&type=script&setup=true&lang=js"

import "./BigScreenDisplay.vue?vue&type=style&index=0&id=27341c64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27341c64"]])

export default __exports__